<template>
  <div>
    <checkout :checkMethod="true"/>
    <div class="row">
      <div class="d-flex flex-row justify-content-end">
        <button class="btn btn-danger" v-if="status === 'false' " @click="methodCard()">پرداخت اعتباری
        </button>
        <button class="btn btn-danger" v-else-if="count >0">
          <div class="spinner-grow fo spinner-grow-sm"><span class="sr-only">  </span></div>
          پرداخت اعتباری ...
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import checkout from "@/agent/components/checkout/listsBasket.vue"
import {useStore} from 'vuex'
import {$ref} from "vue/macros";
import axios from "axios";
import {useToast} from "vue-toastification";
import {useRouter} from "vue-router"
import {computed} from "vue";
const result = defineProps({
  'status': ""
})
const router = useRouter()
const toast = useToast();
const store = useStore();

let status = $ref("false");
let ids = $ref([])


async function methodCard() {
  status = 'true';
  let lists = store.state.listCard;
  console.log(lists);
  for (let i = 0; i < lists.length; i++) {
    let parts = lists[i].ids.split("_");
    ids.push(parts[0]);
  }
  try {
    const response = await axios.post('credits', ids);
    if (response.data.status === "true") {
      ids = "";
      if (response.data.data.status === false) {
        return await router.push({'path': '/agents/panel/register'});
      } else {
      store.commit('tracking', response.data.data);
      toast.success(response.data.messages);
      await router.push({'path': '/agents/panel/result/' + response.data.data});
      status = 'false';
      }
    }
  } catch (error) {
    status = 'false';
    ids = "";
    if (error.response.status === 422) {
      const errorMessages = Object.values(error.response.data.errors).map(val => val[0]);
      errorMessages.forEach(errorMessage => {
        toast.error(errorMessage);
      });
    } else if (error.response.status === 404) {
      if (error.response.data.messages) {
        toast.error(error.response.data.messages);
      } else {
        toast.error('یک خطای غیرمنتظره رخ داد.');
      }
    } else {
      toast.error('یک خطای غیرمنتظره رخ داد.');
    }
  }
}

const count = computed(() => {
  return store.state?.listCard.length
})

</script>
